module.exports = "/images/arrow-right-white.svg?52cd83fa8802099ff02921e3545a0452";